import { render, staticRenderFns } from "./ProjectAccountsTab.vue?vue&type=template&id=c28b45d6&"
import script from "./ProjectAccountsTab.vue?vue&type=script&lang=js&"
export * from "./ProjectAccountsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports